import { mapActions, mapMutations } from 'vuex';
import { bulk } from '@/campaigns/mixins/bulk';

export const archive = {
	mixins: [bulk],
	data() {
		return {
			isArchiving: false,
			isBulkArchiving: false,
		};
	},
	methods: {
		...mapActions('campaigns', ['bulkArchiveCampaigns']),
		...mapMutations('campaigns', ['addAlert']),
		async handle(campaigns, message, loadingKey, modalIdPrefix) {
			this[loadingKey] = true;
			this.bulkArchiveCampaigns({ campaigns })
				.then(() => {
					this.addAlert({ message, type: 'success' });
				})
				.finally(() => {
					this[loadingKey] = false;
					this.$modal.hide(`${modalIdPrefix}-archive-modal`);
				});
		},
		archive() {
			const message = `The ${this.campaign.name} campaign was archived successfully.`;

			this.handle([this.campaign.id], message, 'isArchiving', this.campaign.id);
		},
		bulkArchive() {
			const message = `Successfully archived ${this.count} ${this.campaignPlural}.`;

			this.handle(this.bulk, message, 'isBulkArchiving', 'bulk');
		},
	},
};
